module.exports = __webpack_public_path__ + "img/parter-work9.a474773a.png";